export default function Engagement() {
  return (
    <section
      id="engagement"
      data-testid="engagement-section"
      className="relative px-6 md:px-12 py-24 md:py-32 border-b border-rule bg-sand"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-12 gap-6 md:gap-10">
          <div className="col-span-12 md:col-span-3">
            <div className="overline text-slate reveal">Recent engagement</div>
            <div className="mono text-xs text-slate mt-3 reveal">— 05</div>
          </div>

          <div className="col-span-12 md:col-span-9 lg:col-span-8">
            <div className="bg-paper border border-rule p-8 md:p-10 reveal" data-testid="engagement-card">
              <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
                <div className="overline text-olive">UK · Services business</div>
                <div className="overline text-slate">Currently in flight · Under NDA</div>
              </div>

              <h3 className="serif text-2xl md:text-3xl lg:text-4xl font-light text-ink leading-tight">
                12-month fractional operations engagement
              </h3>

              <p className="mt-5 text-base text-ink/80 max-w-2xl">
                Rebuilding the operating rhythm around a scope expansion the
                existing playbook could not support.
              </p>

              <div className="rule my-8" />

              <dl className="grid grid-cols-2 md:grid-cols-4 gap-y-5 gap-x-6">
                <Spec k="Cadence" v="1 day / week" />
                <Spec k="Embedded" v="Yes" />
                <Spec k="Commercials" v="Fixed fee" />
                <Spec k="Term" v="12 months" />
              </dl>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Spec({ k, v }) {
  return (
    <div>
      <dt className="overline text-slate">{k}</dt>
      <dd className="mt-1.5 serif text-base md:text-lg text-ink font-light">{v}</dd>
    </div>
  );
}
